import React from 'react';
import { AlertCircle, Shield, Swords, Heart } from 'lucide-react';
import type { BattleEffect } from '../../types/battle';

interface BattleLogProps {
  effect: BattleEffect;
}

export function BattleLog({ effect }: BattleLogProps) {
  const getEffectDisplay = () => {
    switch (effect.type) {
      case 'damage':
        return {
          icon: <Swords className="w-5 h-5 text-red-400" />,
          text: `Deals ${effect.value} damage${effect.isCritical ? ' (Critical Hit!)' : ''}`,
          color: 'text-red-400'
        };
      case 'heal':
        return {
          icon: <Heart className="w-5 h-5 text-green-400" />,
          text: `Heals for ${effect.value} HP`,
          color: 'text-green-400'
        };
      case 'shield':
        return {
          icon: <Shield className="w-5 h-5 text-blue-400" />,
          text: `Gains ${effect.value} shield for ${effect.duration} turns`,
          color: 'text-blue-400'
        };
      default:
        return {
          icon: <AlertCircle className="w-5 h-5 text-gray-400" />,
          text: 'No effect',
          color: 'text-gray-400'
        };
    }
  };

  const display = getEffectDisplay();

  return (
    <div className="absolute bottom-4 left-1/2 -translate-x-1/2 px-4 py-2 bg-gray-800/90 rounded-lg animate-fade-in">
      <div className="flex items-center gap-2">
        {display.icon}
        <span className={`font-medium ${display.color}`}>{display.text}</span>
      </div>
    </div>
  );
}